import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getDjangoEndpoint } from "src/utils/apiEndpoints";
import axiosInstance from "src/store/features/auth/axiosCSRF";
export interface iDataListState {
    group_name: string;
    library_name: string;
    step: string;
    extension: string;
    isLoading: boolean;
    message: string | null;
    response: any[];
}

const initialState: iDataListState = {
    group_name: "",
    library_name: "",
    step: "",
    extension: "",
    isLoading: false,
    message: "",
    response: [],
};

// DataList API 호출
export const dataListAPI = createAsyncThunk(
    "DATA_LIST",
    async (params: { group_name: string; library_name: string; step: number; round: number, workflow_name : string }, { rejectWithValue }) => {
        try {
            const djangoEndpoint = getDjangoEndpoint();
            const pathParam = '/workflow/result-list/';
            
            const response = await axiosInstance.post(`${djangoEndpoint}${pathParam}`, {
                group_name: params.group_name,
                library_name: params.library_name,
                step: params.step,
                round : params.round,
                workflow_name : params.workflow_name
            }, {
                withCredentials: true,
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

// DataList Slice
export const dataListSlice = createSlice({
    name: "dataList",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(dataListAPI.pending, (state) => {
                state.isLoading = true;
                state.message = "";
            })
            .addCase(dataListAPI.fulfilled, (state, action) => {
                state.isLoading = false;
                state.response = action.payload;
            })
            .addCase(dataListAPI.rejected, (state, action) => {
                state.isLoading = false;
                state.message = action.payload as string;
            });
    },
});

export default dataListSlice.reducer;